/* eslint-disable no-underscore-dangle */
import { InMemoryCache } from '@apollo/client';
export const apolloCache = new InMemoryCache({});
